import React, { forwardRef } from 'react';

import { Select } from 'antd';
const BaseSearchSelect = (props) => {
  const { label, labelStyle, readonly, width, ...rest } = props;

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '5.8rem',
      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
    },
    label: {
      display: 'flex',
      height: '2rem',
      alignItems: 'center',
      // font
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
      // color: 'black',
    },
    text: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '3.8rem',
      width: '100%',
      padding: 0,
      background: 'transparent',
      border: '1px solid #DBDADE',
      borderRadius: 6,

      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
    },
  };

  return (
    <div style={{ ...styles.container }}>
      <div style={{ ...styles.labe, ...labelStyle }}>{label}</div>
      {readonly ? (
        <div style={{ ...styles.text, paddingRight: 10 }}>
          <div>{props.value}</div>
          <img
            width={20}
            height={20}
            src={require('../../assets/images/arrow_down.png')}
          />
        </div>
      ) : (
        <Select
          showSearch
          placeholder="Search to Select"
          // optionLabelProp="label"
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '').includes(input)
          }
          {...rest}
        />
      )}
    </div>
  );
};

export default forwardRef(BaseSearchSelect);
/*
const provinceData = ['seoul', 'busan'];
   <Select
        defaultValue={provinceData[0]}
        style={{ width: 120 }}
        onChange={handleProvinceChange}
        options={provinceData.map((province) => ({ label: province, value: province }))}
      />
*/
